// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"377":"d28ee265","466":"b1cb9833","770":"370f587d"}[chunkId] + ".chunk.js";
};